var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockFiveDuotone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6C17.302 21.6 21.6 17.3019 21.6 12C21.6 6.69806 17.302 2.39999 12 2.39999C6.69809 2.39999 2.40002 6.69806 2.40002 12C2.40002 17.3019 6.69809 21.6 12 21.6Z",
    fill: "#BABDCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 16.8C15.2928 16.8 14.9856 16.6824 14.7516 16.4484L11.3268 13.0236C10.992 12.6888 10.8 12.2256 10.8 11.7516V5.99999C10.8 5.33759 11.3364 4.79999 12 4.79999C12.6636 4.79999 13.2 5.33759 13.2 5.99999V11.5032L16.4484 14.7516C16.9176 15.2208 16.9176 15.9792 16.4484 16.4484C16.2144 16.6824 15.9072 16.8 15.6 16.8Z",
    fill: "#505363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFiveDuotone);
export default __webpack_public_path__ + "static/media/clock-five_duotone.65193aafb297ea01e419417b31580319.svg";
export { ForwardRef as ReactComponent };